// Resolve the public TrainAxis ID to display for a person (student / trainer /
// admin), tolerant of every response shape. Never exposes MongoDB _id.
//
// Only a real TrainAxis ID (TX-STU / TX-TRN / TX-ADM / TX-SUP) is shown as the
// main ID. Legacy IDs (platformStudentId like TXA-…, or phone-like studentId)
// are intentionally NOT used here — they remain in the backend for backward
// compatibility but must never appear as the primary TrainAxis ID.
const TX_ID_RE = /^TX-(STU|TRN|ADM|SUP)-/i;

export function isValidTxId(v) {
  return typeof v === 'string' && TX_ID_RE.test(v.trim());
}

export function getDisplayTxId(person) {
  if (!person) return 'ID pending';

  const candidate =
    [person.txId, person.userId?.txId, person.user?.txId].find(isValidTxId);

  if (candidate) return candidate.trim().toUpperCase();

  // Dev-only diagnostic — no PII, never logs in production
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('[txId] Missing/invalid TrainAxis ID for a record — backfill may be needed.');
  }
  return 'ID pending';
}
